<template>
  <div>
    <div v-if="items">
      <v-row class="ma-2">
        <v-text-field v-model="loot.table.search" append-icon="mdi-magnify" :label="$t('general.misc.search')"
                      clearable hide-details></v-text-field>
        <v-autocomplete class="ml-2" :label="$t('char_detail.loot.table.typ')" :items="loot.types"
                        v-model="loot.type" clearable hide-details return-object></v-autocomplete>
        <v-autocomplete class="ml-2" :label="$t('char_detail.loot.table.episode')" :items="loot.episodes"
                        v-model="loot.episode" hide-details return-object v-if="seasonFilter"></v-autocomplete>
        <v-checkbox :label="$t('char_detail.loot.show_copied')" v-model="loot.includeCopiedItems" v-if="copiedItemsFilter"></v-checkbox>
      </v-row>
      <v-row class="ma-2 mt-2">
        <v-autocomplete :label="$t('char_detail.loot.table.choice')" :items="loot.choices"
                        v-model="loot.choice" clearable multiple small-chips hide-details return-object>
        </v-autocomplete>
      </v-row>
      <v-row class="ma-2 align-center justify-end">
        <v-btn class="ml-2 mt-2 primary" @click="resetFilter">
          <v-icon>mdi-close-circle</v-icon>
          {{ $t('char_detail.loot.reset_filter') }}
        </v-btn>
      </v-row>
      <v-data-table :headers="filterHeader" :items="filterItems" item-key="id"
                    :search="loot.table.search" :sort-by.sync="loot.table.sortBy" :sort-desc="true"
                    :page.sync="loot.table.page" :items-per-page="loot.table.itemsPerPage" hide-default-footer
                    @page-count="loot.table.pageCount = $event"
                    :custom-filter="Utilities().searchNormalized">
        <template v-slot:item.name="{ item }">
          <div class="ml-1 align-center d-table">
            <div class="mt-1 mr-3" style="width: 30px; display: inline-block; text-align: center;">
              <a v-bind:href="'https://www.wowhead.com/item=' + item.itemId"
                 :data-wowhead="EquipmentHelper().getItemContext(item, $i18n.locale)"
                 target="_blank"><img class="raid-item" v-bind:src="item.media" alt="raid-item"></a>
            </div>
            <p class="pl-2 font-weight-medium d-table-cell" style="vertical-align: middle">
              {{ item.name }}
            </p>
          </div>
        </template>
        <template v-slot:item.roster="{ item }">
                  <span v-if="item.roster === 'fire'">
                      <v-chip label class="ml-2 noHover" color="primary" outlined small>
                        <v-icon left>mdi-fire</v-icon>
                        Feuer
                      </v-chip>
                    </span>
          <span v-else>
                    <v-chip label class="ml-2 noHover" color="#298F85" outlined small>
                      <v-icon left>mdi-fire</v-icon>
                      Flamme
                    </v-chip>
                  </span>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ new Date(item["createdAt"]).toLocaleDateString() }}
        </template>
        <template v-slot:item.visibleItem="{ item }">
          <v-icon medium :color="item.visibleItem ? 'red' : 'green'">
            {{ item.visibleItem ? 'mdi-close-circle' : 'mdi-check-circle' }}
          </v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-else>
      <v-icon class="mr-2">mdi-close-circle</v-icon>
      {{ $t("char_detail.loot.no_items") }}
    </div>
  </div>
</template>

<script>
import EquipmentHelper from "@/features/equipment/EquipmentHelper";
import Utilities from "@/util/Utilities";

export default {
  name: "ReceivedLootTable",
  props: ["items", "multiCharacterView", "seasonFilter", "copiedItemsFilter"],
  data() {
    return {
      loot: {
        episodes: ["All"],
        episode: "All",
        currentEpisode: "",
        includeCopiedItems: false,
        type: null,
        types: [],
        character: null,
        choice: null,
        choices: [],
        table: {
          search: '',
          page: 1,
          pageCount: 0,
          itemsPerPage: 15,
          sortBy: "createdAt"
        }
      }
    }
  },
  mounted() {
    console.log(this.items);
    let appConfig = this.$store.getters["data/appConfig"];
    let lootEpisodes = appConfig.find(x => x.key === "LOOT_EPISODES");
    if (lootEpisodes) {
      let episodeValues = lootEpisodes.value.split(";");
      episodeValues = episodeValues.sort((a, b) => a.localeCompare(b));
      episodeValues.forEach(value => {
        this.loot.episodes.push(value);
      });
    }

    let currentEpisode = appConfig.find(x => x.key === "CURRENT_LOOT_EPISODE");
    if (currentEpisode) {
      this.loot.episode = currentEpisode.value;
      this.loot.currentEpisode = currentEpisode.value;
    }

    this.loot.choices = [...new Set(this.items.map(x => x.choice))];
    this.loot.choice = [...new Set(this.items.map(x => x.choice))];
    this.loot.types = [...new Set(this.items.map(x => x.type))];
  },
  methods: {
    Utilities() {
      return Utilities
    },
    EquipmentHelper() {
      return EquipmentHelper
    },
    resetFilter(){
      this.loot.table.search = "";
      this.loot.episode = this.loot.currentEpisode;
      this.loot.choice = this.loot.choices;
      this.loot.type = null;
      this.loot.character = null;
      this.loot.includeCopiedItems = false;
    }
  },
  computed: {
    filterHeader(){
      let headers = [
        {text: this.$t('char_detail.loot.table.name'), value: "name"},
        {text: this.$t('char_detail.loot.table.choice'), value: "choice"},
        {text: this.$t('char_detail.loot.table.typ'), value: "type"},
        {text: this.$t('char_detail.loot.table.date'), value: "createdAt"},
      ]

      if(this.seasonFilter){
        headers.push({text: this.$t('char_detail.loot.table.episode'), value: "lootEpisode"}) ;
      }

      if(this.loot.includeCopiedItems){
        headers.push({text: this.$t('char_detail.loot.table.copied'), value: "visibleItem"}) ;
      }

      return headers;
    },
    filterItems() {
      let loot = this.items;
      if (this.loot.episode !== "All") {
        loot = loot.filter(x => x.lootEpisode === this.loot.episode);
      }

      if(this.loot.type !== null){
        loot = loot.filter(x => x.type === this.loot.type);
      }

      if(this.loot.choice !== null){
        loot = loot.filter(x => this.loot.choice.includes(x.choice));
      }

      if(this.loot.character !== null){
        loot = loot.filter(x => x.character === this.loot.character.id);
      }

      if(!this.loot.includeCopiedItems){
        loot = loot.filter(x => x.visibleItem);
      }

      return loot;
    },
  }
}
</script>

<style scoped>

</style>